
import Vue from 'vue'
import { auth } from '@/firebase'

import JUserAvatar from '@/ui/controls/JUserAvatar.vue'

export default Vue.extend({
  components: {
    JUserAvatar,
  },
  props: {
    user: Object,
  },
  data: () => ({
    menu: false,
    dialog: false,

    loading: false,
  }),
  methods: {
    changePassword() {
      this.loading = true
      const emailAddress = this.user.email

      auth
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          this.$store.dispatch(
            'snackbars/success',
            `Sent email to ${emailAddress}`
          )
        })
        .catch((err) => {
          this.$store.dispatch('snackbars/error', err.message || err)
        })
        .finally(() => {
          this.loading = false
          this.dialog = false
        })
    },
  },
})
